export class BatchManager {
    static registerProvider(renderType, cls) {
        if (BatchManager.registry[renderType])
            throw new Error("Overlapping batch optimization");
        BatchManager.registry[renderType] = cls;
    }
    static createProvider(renderType) {
        return new (BatchManager.registry[renderType] || NullBatchProvider)();
    }
}
BatchManager.registry = {};
class NullBatchProvider {
    batch(list, start, end, allowReorder) {
        for (let i = start; i <= end; i++)
            list.add(list.elements[i]);
    }
    reset() { }
    destroy() { }
}
